export default __webpack_public_path__ + "static/media/1012.961aae04.png";